import { Exception } from '@core/exceptions/exception';

export class AuthContextNotFoundException extends Exception {
  constructor(message = 'The auth context is not found.') {
    super(message);
  }
}
